/**
 * A component to be used as a drop in replacement for native <img> tag. The src attribute will be
 * used on render time to query image via Gatsby's graphQl bingings, which will result
 * in a responsive and optimized image.
 *
 * NOTE: styles may need updating after switching from <img>, because of a nested component
 * structure.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import BackgroundImage from 'gatsby-background-image';
import useOptimizedImage from '../graphql/staticQueries/useOptimizedImage';

const OptimizedImage = ({
  src,
  alt,
  title,
  className,
  background,
  style,
  children,
  imgStyle
}) => {
  const imageFluid = useOptimizedImage(src).fluid;
  if (!background) {
    return (
      <Img
        fluid={imageFluid}
        alt={alt}
        title={title}
        className={`img ${className}`}
        placeholderClassName="optimized-image-placeholder"
        style={style}
        imgStyle={imgStyle}
      />
    );
  }
  return (
    <BackgroundImage fluid={imageFluid} className={className} style={style}>
      {children}
    </BackgroundImage>
  );
};

OptimizedImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  background: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object
};

OptimizedImage.defaultProps = {
  alt: 'Ulam Labs',
  title: '',
  className: '',
  background: false,
  style: {}
};

export default OptimizedImage;
